import OrderStepComplete from "@affinity/components/OrderSteps/OrderStepComplete";
import { formatAddress, formatPriceAndDelivery, getQuantityDescription } from "@affinity/constants/FormatHelpers";
import { colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem, transparentize } from "@affinity/constants/StyleHelpers";
import PlaceOrderRevertToStep from "@affinity/Handlers/PlaceOrderRevertToStep";
import { CustomState } from "@affinity/Store/Reducers";
import { AffinityDelivery, AffinityProduct } from "@affinity/Store/StoreTypes";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled from "styled-components";

export type OwnProps = {
    currentStep: number;
};
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const StyledList = styled.ul<InjectableCss>`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${rem(15)};
    @media (min-width: ${breakpointWidth("lg")}) {
        gap: ${rem(20)};
    }
`;

export const StyledFigureSteps = styled.figure`
    margin: 0;
    background-color: ${transparentize(colours.white, 0.5)};
    padding: ${rem(20)};
    border-radius: ${rem(10)};
    @media (min-width: ${breakpointWidth("lg")}) {
        padding: ${rem(30)};
        border-radius: ${rem(15)};
    }
`;

function placeOrderCompletedStepLabels(currentStep: number) {
    const completedStepLabels = [
        "Fuel type: ",
        "Quantity: ",
        "Delivery address: ",
        "Price and delivery options: ",
        "Delivery instructions: ",
    ];

    // Number should be 0 indexed (should be step enum from state file)
    return completedStepLabels.slice(0, currentStep + 1);
}

function placeOrderCompleteStepModel(state: CustomState, currentStep: number) {
    // add state to get data
    const affinityPlaceOrder = state.affinity_place_order;
    const labels = placeOrderCompletedStepLabels(currentStep);

    const data = [
        affinityPlaceOrder.selectedProduct === AffinityProduct.Regular ? "Regular" : "Premium",
        getQuantityDescription(affinityPlaceOrder.quantity || 0),
        formatAddress(affinityPlaceOrder.selectedAddress),
        affinityPlaceOrder.priceAndDelivery === AffinityDelivery.Cheapest
            ? formatPriceAndDelivery({ ...affinityPlaceOrder.deliveryCheapest! })
            : formatPriceAndDelivery({ ...affinityPlaceOrder.deliverySoonest! }),
        affinityPlaceOrder.deliveryInstructions,
    ].slice(0, currentStep);

    const results = [];

    for (let i = 0; i < currentStep - 1; i++) {
        results.push({
            label: labels[i],
            data: data[i],
        });
    }

    return results;
}

const mapStateToProps = (state: CustomState) => ({
    steps: placeOrderCompleteStepModel(state, state.affinity_place_order.currentStep),
});

const mapDispatchToProps = {
    PlaceOrderRevertToStep,
};

export const PlaceOrderStepsCompleted: FC<Props> = ({ steps, PlaceOrderRevertToStep }) => {
    return (
        <StyledFigureSteps>
            <VisuallyHidden as="figcaption">Completed steps:</VisuallyHidden>
            <StyledList>
                {steps.map((item, idx) => (
                    <OrderStepComplete
                        text1={item.label}
                        text2={item.data || ""}
                        onClick={() => PlaceOrderRevertToStep({ step: idx + 1 })}
                        key={item.label}
                    />
                ))}
            </StyledList>
        </StyledFigureSteps>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaceOrderStepsCompleted);
